<!-- 回测分析 -->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title">
      <p class="name">回测分析</p>
      <p class="right">
        持股周期
        <span> {{ periodArr.toString() }}天 </span>
      </p>
    </div>

    <div ref="hcfx">
      <div class="fc-title-sticky">
        <van-sticky :offset-top="tabsHeight + headerHeight - 2" :container="hcfx" z-index="98">
          <ul class="fc-title">
            <li></li>
            <li>持有期</li>
            <li>区间均涨幅</li>
            <li>盈亏比</li>
            <li style="text-align: right">上涨概率</li>
          </ul>
        </van-sticky>
      </div>
      <ul class="list" v-for="(item, index) in BacktestAnalysisResult" :key="item.HoldPeriod">
        <li class="zybox-list-left">
          <p class="excellent" v-if="maxAvgSectionRateIndex === index">涨幅</p>

          <p class="probability" v-if="maxRiseProbabilityIndex === index">概率</p>
        </li>

        <li>{{ item.HoldPeriod }}天</li>
        <li :class="[judgeColor(item.AvgSectionRate)]">
          {{ toFixedNum(item.AvgSectionRate * 100, 2, '%') }}
        </li>
        <li>
          {{ toFixedNum(item.ProfitLossRatio, 2, '') }}
        </li>
        <li style="text-align: right">{{ toFixedNum(item.RiseProbability * 100, 2, '%') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { judgeColor, toFixedNum, formatStrTime } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Home',
  mixins: [mixin],
  props: ['BacktestAnalysisResult', 'holdPeriodList', 'headerHeight', 'tabsHeight'],
  data() {
    return {
      maxAvgSectionRateIndex: 0,
      maxRiseProbabilityIndex: 0,
      periodArr: '',
      hcfx: null
    };
  },
  filters: {},
  created() {},
  watch: {},
  mounted() {
    this.hcfx = this.$refs.hcfx;

    this.periodArr = this.holdPeriodList.split(',');
    var indices = this.getMaxIndices(
      this.BacktestAnalysisResult,
      'AvgSectionRate',
      'RiseProbability'
    );

    this.maxAvgSectionRateIndex = indices.maxAvgSectionRateIndex;
    this.maxRiseProbabilityIndex = indices.maxRiseProbabilityIndex;
  },

  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime,

    //获取最大值AvgSectionRate(平均区间涨幅)和RiseProbability(上涨概率)最大值的索引用来高亮
    getMaxIndices: function (data, avgSectionRateKey, riseProbabilityKey) {
      let maxAvgSectionRateIndex = 0;
      let maxRiseProbabilityIndex = 0;
      let maxAvgSectionRate = data[0][avgSectionRateKey];
      let maxRiseProbability = data[0][riseProbabilityKey];

      for (let i = 1; i < data.length; i++) {
        if (data[i][avgSectionRateKey] > maxAvgSectionRate) {
          maxAvgSectionRate = data[i][avgSectionRateKey];
          maxAvgSectionRateIndex = i;
        }

        if (data[i][riseProbabilityKey] > maxRiseProbability) {
          maxRiseProbability = data[i][riseProbabilityKey];
          maxRiseProbabilityIndex = i;
        }
      }

      return {
        maxAvgSectionRateIndex,
        maxRiseProbabilityIndex
      };
    }
  }
};
</script>
<style lang="less" scoped>
.index-info {
  padding: 15px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .name {
      flex-shrink: 0;
    }
    p {
      font-weight: 600;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
    }
    .right {
      font-weight: 400;
      font-size: 12px;
      color: #999;
      margin-left: 2px;
    }
  }
  .fc-title-sticky {
    ::v-deep {
      .van-sticky--fixed {
        left: 15px;
        right: 15px;
      }
    }
  }
  .fc-title {
    display: flex;
    align-items: center;
    border-top: 1px solid #f0f0f0;
    padding: 4px 0;
    background: #fff;
    width: 100%;
    li {
      font-weight: 400;
      font-size: 12px;
      color: #999;
      &:nth-child(1) {
        width: 16%;
      }
      &:nth-child(2) {
        width: 21%;
      }
      &:nth-child(3) {
        width: 26%;
      }
      &:nth-child(4) {
        width: 21%;
      }
      &:nth-child(5) {
        width: 16%;
      }
    }
  }
  .zybox-list-left {
    // border: 1px solid red;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }

  .list {
    display: flex;
    align-items: center;
    border-top: 1px solid #f0f0f0;
    li {
      font-weight: 400;
      font-size: 14px;
      color: #555;
      padding: 12px 0;
      &:nth-child(1) {
        width: 16%;
      }
      &:nth-child(2) {
        width: 21%;
      }
      &:nth-child(3) {
        width: 26%;
      }
      &:nth-child(4) {
        width: 21%;
      }
      &:nth-child(5) {
        width: 16%;
      }

      .excellent,
      .probability {
        // flex-shrink: 0;
        // width: 28px;
        // height: 16px;
        // line-height: 16px;
        // border-radius: 2px;
        // font-weight: 400;
        // font-size: 10px;
        // color: #fff;
        // text-align: center;
        // padding: 1px 2px;
        // margin: 2px;
        width: 18px;
        height: 30px;
        line-height: 14px;
        display: inline-flex;
        padding: 2px 3px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: #fff;
        font-size: 10px;
        font-weight: 400;
        border-radius: 2px;
        margin-right: 4px;
      }
      .excellent {
        background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
      }
      .probability {
        background: linear-gradient(270deg, #e47813 0%, #ffbe5e 100%);
      }
    }

    &:last-child {
      border-bottom: 1px solid #f0f0f0;
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title {
    .name {
      color: #e4e9fe;
    }
    .right {
      color: #6b7687;
    }
  }
  .list {
    .right {
      color: #e4e9fe;
    }
  }
  .fc-title-sticky {
    .fc-title {
      background: #191a24;
      border-top: 1px solid #2f3139;
      li {
        color: #6b7687;
      }
    }
  }
  .list {
    border-top: 1px solid #2f3139;
    &:last-child {
      border-bottom: 1px solid #2f3139;
    }
    li {
      color: #e4e9fe;
    }
  }
}
</style>
